import {Vue} from 'vue-property-decorator';
import {State} from 'vuex-class';
export default class Utils extends Vue {
  @State((state) => state.currentIndex)
  public currentIndex!: any;
  public imgBaseUrl: string = '//antilose.i-mineral.cn/';
  public saveNavIndex(index: string) {
    sessionStorage.setItem('navIndex', index);
  }
  public getNavIndex() {
    return sessionStorage.getItem('navIndex');
  }
}
